module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Design/Join-1-1a7d48dc5233e659b91707e3918f9ef9.svg";